export default "/images/logo.png?79f62a808d8458339e6d97cd1c388090";